import React from 'react';
import GameAddEdit from '../../../components/admin/GameAddEdit/GameAddEdit';
import styles from './AdminBannerCreate.module.scss';
import SupportAddEdit from '../../../components/admin/SupportAddEdit/SupportAddEdit';
import BannerAddEdit from '../../../components/admin/BannerAddEdit/BannerAddEdit';
const AdminBannerCreate = () => {
  return <BannerAddEdit />;
};

export default AdminBannerCreate;
